{
  "fields": {
    "email": "Email",
    "password": "Password"
  },
  "errors": {
    "emailRequired": "Email is required",
    "emailInvalid": "Invalid email address",
    "passwordRequired": "Password is required",
    "invalidCredentials": "Incorrect email or password",
    "captchaFailed": "Verification failed, please try again",
    "locked": "Account temporarily locked, try again in {{minutes}} minutes",
    "disabled": "Account disabled, please contact the administration"
  },
  "login": {
    "title": "Sign in",
    "intro": "For owners and booking coordinators. You'll be taken to the right dashboard for your account.",
    "expired": "Your session expired, please sign in again.",
    "resetDone": "Password set, you can sign in now.",
    "forgot": "Forgot password?",
    "submit": "Sign in",
    "submitting": "Signing in…",
    "lockHint": "After 5 failed attempts the account is locked for 15 minutes."
  },
  "forgot": {
    "title": "Forgot password",
    "intro": "Enter your email and we'll send you a link to reset your password.",
    "done": "If the email is registered, you'll receive a message with a reset link within minutes. The link is valid for one hour.",
    "submit": "Send link",
    "backToLogin": "Back to sign in"
  },
  "setPassword": {
    "titleInvite": "Set password",
    "titleReset": "Reset password",
    "invalidLink": "This link is invalid or has expired. Request a new one.",
    "requestNew": "Request a new link",
    "greeting": "Hello {{name}}, choose a password for <email>{{email}}</email>.",
    "newPassword": "New password",
    "hint": "At least 10 characters, including a letter and a digit",
    "strengthLabel": "Password strength: {{level}}",
    "strength": {
      "weak": "Weak",
      "medium": "Medium",
      "strong": "Strong"
    },
    "confirm": "Confirm password",
    "submit": "Save password",
    "errors": {
      "min": "At least 10 characters",
      "letter": "Must contain a letter",
      "digit": "Must contain a digit",
      "mismatch": "Passwords do not match"
    },
    "contractSigned": "The contract is signed and a PDF copy is on its way to your email. Finish registering by choosing a password."
  }
}
